// components/GlobalLoader.tsx

import { useLoading } from "../Context/LoadingContext";

export default function GlobalLoader() {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div
      className="
      fixed inset-0
      bg-black/40
      z-[9999]
      flex items-center justify-center"
    >
      <div
        className="
        bg-white
        px-8 py-5
        rounded-xl
        shadow-xl"
      >
        <div className="flex items-center gap-3">
          <div
            className="
            h-5 w-5
            border-2
            border-blue-500
            border-t-transparent
            rounded-full
            animate-spin
            "
          />

          <span>
            جاري تنفيذ العملية...
          </span>
        </div>
      </div>
    </div>
  );
}